// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconLinearUserOctagon = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '24',
      height: '24',
      viewBox: '0 0 16 16',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M14.0528 5.72067L14.0528 10.2807C14.0528 11.0273 13.6528 11.7207 13.0061 12.1007L9.04612 14.3873C8.39945 14.7607 7.59945 14.7607 6.94612 14.3873L2.98612 12.1007C2.33945 11.7273 1.93945 11.034 1.93945 10.2807L1.93945 5.72067C1.93945 4.97401 2.33945 4.28065 2.98612 3.90065L6.94612 1.61398C7.59279 1.24065 8.39279 1.24065 9.04612 1.61398L13.0061 3.90065C13.6528 4.28065 14.0528 4.96734 14.0528 5.72067Z',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.99865 7.33321C8.85653 7.33321 9.55198 6.63775 9.55198 5.77987C9.55198 4.92198 8.85653 4.22656 7.99865 4.22656C7.14076 4.22656 6.44531 4.92198 6.44531 5.77987C6.44531 6.63775 7.14076 7.33321 7.99865 7.33321Z',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.6654 11.1069C10.6654 9.90689 9.47203 8.93359 7.9987 8.93359C6.52536 8.93359 5.33203 9.90689 5.33203 11.1069',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
  );

export { IconLinearUserOctagon };
